import { useContext } from 'react';

import MeasureChart from '@/components/MeasureChart';
import PageHeader from '@/components/PageHeader';
import RenderHTML from '@/components/RenderHTML';
import useAPI from '@/hooks/useAPI';
import PersonContext from '@/pages/Person/PersonContext';
import MetricRepository from '@/repositories/MetricsRepository';
import Accordion from '@/ui/components/Accordion';
import Card from '@/ui/components/Card';
import Container from '@/ui/components/Container';
import Heading from '@/ui/components/Heading';
import LoadingSkeleton from '@/ui/components/LoadingSkeleton';

const PersonMetrics = () => {
  const { person } = useContext(PersonContext);
  const metricRepository = MetricRepository();

  const {
    data: personMetricsResponse,
    isError: personMetricsError,
    isPending: personMetricsPending
  } = useAPI({
    queryKey: ['getPersonMetrics', person.id],
    queryFn: async () => {
      return await metricRepository.metrics(person.id);
    }
  });

  return (
    <Container type="page">
      <PageHeader headingText="Metrics" className="sr-only" />
      {personMetricsPending ? (
        <LoadingSkeleton />
      ) : (
        <>
          {personMetricsError ? (
            <p>Failed to load metrics</p>
          ) : (
            personMetricsResponse?.data?.map((metric) => (
              <Card key={metric.key} className="mb-4">
                <Heading level={3} className="w-full">
                  <div className="flex items-center justify-between">
                    <span>{metric.name}</span>
                    {metric.most_recent_metric && (
                      <span className="text-xs">Last: {metric.most_recent_metric?.value}</span>
                    )}
                  </div>
                </Heading>
                <Accordion buttonText={metric.description} className="mb-3">
                  <RenderHTML html={metric.rich_description} />
                </Accordion>

                {metric.most_recent_metric && (
                  <Accordion buttonText="View">
                    <MeasureChart person={person} measureKey={metric.key} />
                  </Accordion>
                )}
              </Card>
            ))
          )}
        </>
      )}
    </Container>
  );
};

export default PersonMetrics;
